const Storage = require('utils/storage');
const PersistenceConfig = require('utils/persistence-config');
const ProfilePhotoStateUtils = require('./profilePhotoStateUtils');
const SubmitStateUtils = require('./submitStateUtils');

const internals = {};

internals.setValidSubmitDebug = (payload) => {

    if (typeof window === 'undefined') {
        return;
    }

    window.__FORM_DEBUG_LAST_VALID_SUBMIT__ = {
        at: new Date().toISOString(),
        ...payload
    };

    if (
        Storage.getItem(PersistenceConfig.keys.debug.formEnabled) === '1'
        || new URLSearchParams(window.location.search).get('formDebug') === '1'
    ) {
        // eslint-disable-next-line no-console
        console.log('[FormDebug] valid submit', window.__FORM_DEBUG_LAST_VALID_SUBMIT__);
    }
};

exports.submitSignupDetails = async ({
    shouldRedirect,
    values,
    successRedirectPath,
    getSignupDetails,
    onSubmit,
    onSubmitNoRedirect
}) => {

    const signupDetails = getSignupDetails(values);

    if (shouldRedirect) {
        return onSubmit(signupDetails, successRedirectPath);
    }

    await onSubmitNoRedirect(signupDetails);
    return null;
};

exports.shouldSettleSuccessfulSubmit = ({
    shouldRedirect,
    onSubmitResults
}) => {

    return !shouldRedirect || !onSubmitResults?.payload;
};

exports.performValidSubmit = async ({
    existingPicture,
    getFieldValue,
    croppedPicture,
    saveProfilePicture,
    shouldRedirect,
    values,
    successRedirectPath,
    getSignupDetails,
    onSubmit,
    onSubmitNoRedirect,
    stillExists,
    setUiState
}) => {

    try {
        const picFile = getFieldValue('picFile');
        const picPreviewURL = getFieldValue('picPreviewURL');

        internals.setValidSubmitDebug({
            phase: 'start',
            shouldRedirect,
            successRedirectPath,
            hasPicFile: !!picFile,
            hasPicPreviewURL: !!picPreviewURL,
            hasCroppedPicture: !!croppedPicture,
            existingPicture
        });

        await ProfilePhotoStateUtils.clearProfilePictureOnSubmitIfNeeded({
            existingPicture,
            picFile,
            croppedPicture,
            picPreviewURL,
            saveProfilePicture
        });

        const signupDetails = getSignupDetails(values);

        internals.setValidSubmitDebug({
            phase: 'before-submit',
            shouldRedirect,
            successRedirectPath,
            signupDetails
        });

        const onSubmitResults = shouldRedirect
            ? await onSubmit(signupDetails, successRedirectPath)
            : await onSubmitNoRedirect(signupDetails);

        internals.setValidSubmitDebug({
            phase: 'submitted',
            shouldRedirect,
            successRedirectPath,
            signupDetails,
            onSubmitResults,
            resultHasPayload: !!onSubmitResults?.payload,
            resultType: onSubmitResults?.type
        });

        if (exports.shouldSettleSuccessfulSubmit({
            shouldRedirect,
            onSubmitResults
        })) {
            SubmitStateUtils.setSubmitSettledStateIfMounted({
                stillExists,
                setUiState
            });
        }
    }
    catch (err) {
        internals.setValidSubmitDebug({
            phase: 'error',
            shouldRedirect,
            successRedirectPath,
            message: err?.message,
            stack: err?.stack
        });

        // eslint-disable-next-line no-console
        console.error('[FormDebug] valid submit failed', err);

        SubmitStateUtils.setSubmitSettledStateIfMounted({
            stillExists,
            setUiState,
            pageHasErrors: true
        });

        throw err;
    }
};

exports.submitWhenValid = ({
    setUiState,
    performValidSubmit
}) => {

    setUiState(
        SubmitStateUtils.buildSubmittingState(),
        performValidSubmit
    );
};

exports.buildValidSubmitOptions = ({
    existingPicture,
    getFieldValue,
    croppedPicture,
    saveProfilePicture,
    shouldRedirect,
    values,
    successRedirectPath,
    getSignupDetails,
    onSubmit,
    onSubmitNoRedirect,
    stillExists,
    setUiState
}) => {

    return {
        existingPicture,
        getFieldValue,
        croppedPicture,
        saveProfilePicture,
        shouldRedirect,
        values,
        successRedirectPath,
        getSignupDetails,
        onSubmit,
        onSubmitNoRedirect,
        stillExists,
        setUiState
    };
};
